import { TenantUserFields } from "../TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { HumanModel } from "./Human";
import { AddressModel } from "./Address";
import { ContactModel } from "./Contact";

export class FieldsModel extends Model  {
    fieldkey: string;
    fieldval: string = "";
    asgroup: boolean = false;
    locked: boolean = false;
    data: object = {}
    
    is_deleted:boolean = false;
    
    constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data);
        }
        
    }
}